import { createModule } from '../store.utils'

export const UserModule = createModule({
  state: {
    name: '',
  },
  mutations: {},
  actions: {},
})
